export const routes = {
	NOTIFY_AUTH: {
		URL: '/v1/auth/authorize',
		METHOD: 'POST',
	},
	NOTIFY_CALLBACK_REQUEST: {
		URL: '/v1/institute-dashboard/callback-request',
		METHOD: 'POST',
	},
	NOTIFY_SUPPORT_REQUEST: {
		URL: '/v1/institute-dashboard/support-request',
		METHOD: 'POST',
	},
	NOTIFY_RESET_PASSWORD: {
		URL: '/v1/institute-dashboard/reset-password-token',
		METHOD: 'POST',
	},
	NOTIFY_CREATE_PASSWORD: {
		URL: '/v1/institute-dashboard/password-changed',
		METHOD: 'POST',
	},
	NOTIFY_MOBILE_OTP: {
		URL: 'v1/customer-portal/otp/send-otp',
		METHOD: 'POST',
	}
};
